// @ts-nocheck
/* eslint-disable */
export const wrongIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 10"><path fill="currentColor" d="M6.622 10 4.284 6.192 2.058 10H.644l2.982-4.872L.63.242h1.428L4.41 4.064 6.65.242h1.428l-3.01 4.886L8.064 10z"/></svg>`,
    name: 'wrong' as const
};